export const ADDED_CHECKED_BAGGAGE = 'ADDED_CHECKED_BAGGAGE';
export const INCLUDED_CHECKED_BAGGAGE = 'INCLUDED_CHECKED_BAGGAGE';
export const INFANT_NO_CHECKED_BAGGAGE = 'INFANT_NO_CHECKED_BAGGAGE';
export const NO_CHECKED_BAGGAGE = 'NO_CHECKED_BAGGAGE';
export const NO_CHECKED_BAGGAGE_AVAILABLE = 'NO_CHECKED_BAGGAGE_AVAILABLE';
export const ADDED_CABIN_BAGGAGE = 'ADDED_CABIN_BAGGAGE';
export const INCLUDED_CABIN_BAGGAGE = 'INCLUDED_CABIN_BAGGAGE';
export const INFANT_NO_CABIN_BAGGAGE = 'INFANT_NO_CABIN_BAGGAGE';
export const NO_CABIN_BAGGAGE = 'NO_CABIN_BAGGAGE';
export const NO_CABIN_BAGGAGE_AVAILABLE = 'NO_CABIN_BAGGAGE_AVAILABLE';
export const INCLUDED_AND_ADDED_CABIN_BAGGAGE = 'INCLUDED_AND_ADDED_CABIN_BAGGAGE';
export const NO_PERSONAL_ITEM = 'NO_PERSONAL_ITEM';
export const INCLUDED_PERSONAL_ITEM = 'INCLUDED_PERSONAL_ITEM';
export const INFANT_NO_PERSONAL_ITEM = 'INFANT_NO_PERSONAL_ITEM';
